<template>
  <el-dialog title="出库给经销商" :visible.sync="outVisible" width="650px" :before-close="handleClose" :close-on-click-modal="false" center>
    <div class="from-body">
      <el-form :model="ruleForm" ref="ruleForm" :rules="rules" label-width="auto" class="demo-ruleForm">
        <el-form-item label="选经销商" prop="orgId">
          <el-cascader
            :options="orgList"
            :props="orgProps"
            v-model="ruleForm.orgId"
            style="width:400px"
            clearable
            placeholder="请选择"
          />
        </el-form-item>
        <el-form-item label="出库日期" prop="orgDate">
          <el-date-picker v-model="ruleForm.orgDate" type="date" style="width:400px" format="yyyy-MM-dd" value-format="yyyy-MM-dd"/>
        </el-form-item>
      </el-form>
      <div style="height: 20px;">&nbsp;</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose" style="margin-right:50px;">关 闭</el-button>
        <el-button @click="submit" type="primary">提 交</el-button>
      </span>
    </div>
  </el-dialog>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      orgList: [], 
      orgProps: {
        children: "orgList",
        label: "name",
        value: "id",
        checkStrictly: true,
      },
      ruleForm: {
        orgId: null,
        orgDate: null,
      },
      components: { },
      rules: {
        orgId: [
          {
            required: true,
            message: "经销商不能为空",
            trigger: "blur",
          }
        ],
        orgDate: [
          {
            required: true,
            message: "出库日期不能为空",
            trigger: "blur",
          }
        ],
      }
    };
  },
  computed: {
    ...mapState(["buttonTextColor"]),
  },
  props: ["outVisible","gateway"],
  watch: {
    outVisible(newValue) {
      if (newValue) {
        this.listOrg();
      }
    },
  },
  methods: {
    listOrg() {
      this.request.listOrg().then((res) => {
        if (res.code == 0) {
          this.orgList = [res.data];
        }
      });
    },
    onInput() {
      this.$forceUpdate();
    },
    handleClose() {
      this.ruleForm = {
        orgId: null,
        orgDate: null,
      };
      this.$emit("handleClose");
    },
    submit() {
      if (this.ruleForm.orgId==null||this.ruleForm.orgId=="") {
        this.$message.error("经销商不能为空");
        return;
      } 
      if (this.ruleForm.orgDate==null||this.ruleForm.orgDate=="") {
        this.$message.error("出库日期不能为空");
        return;
      } 
      var param={
        "gateway": this.gateway,
        "orgId": this.ruleForm.orgId,
        "orgDate": this.ruleForm.orgDate,
      };
      this.request.assignOrg(param).then((res) => {
        if (res.code==0) {
          this.handleClose();
        }
      });
    },
  },
};
</script>
<style scoped>
.from-body {
  padding: 0 60px;
  box-sizing: border-box;
}
::v-deep .el-table .el-table__row {
  height: 44px;
}
::v-deep .el-table .cell {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>